import React, { useState, useEffect } from 'react';
import { Outlet, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AppContext';
import api from '../api';

const LOGO_URL = '/logo.png';

const navItems = [
  { section: 'Main' },
  { to: '/admin/dashboard',    icon: 'bi-speedometer2',  label: 'Dashboard' },
  { section: 'Content' },
  { to: '/admin/projects',     icon: 'bi-building',      label: 'Projects' },
  { to: '/admin/services',     icon: 'bi-tools',         label: 'Services' },
  { to: '/admin/testimonials', icon: 'bi-chat-quote',    label: 'Testimonials' },
  { section: 'Communication' },
  { to: '/admin/messages',     icon: 'bi-envelope',      label: 'Messages' },
  { section: 'System' },
  { to: '/admin/settings',     icon: 'bi-gear',          label: 'Settings' },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const navigate = useNavigate();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [settings, setSettings]       = useState({});
  const [logoOk, setLogoOk]           = useState(true);

  useEffect(() => {
    api.get('/settings').then(r => setSettings(r.data.data || {})).catch(() => {});
  }, []);

  const handleLogout = () => { logout(); navigate('/admin/login'); };
  const siteName = settings.site_name || 'Bacha & Son';
  const [brand, accent] = siteName.includes(' ')
    ? [siteName.split(' ')[0], ' ' + siteName.split(' ').slice(1).join(' ')]
    : [siteName, ''];

  const Sidebar = () => (
    <div className={`admin-sidebar ${sidebarOpen ? 'open' : ''}`}>
      <div className="sidebar-logo">
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          {logoOk && (
            <img src={LOGO_URL} alt={siteName} className="sidebar-logo-img"
              onError={() => setLogoOk(false)} />
          )}
          <div>
            <div className="sidebar-logo-text">{brand}<span>{accent}</span></div>
            <div style={{ fontSize: '9px', letterSpacing: 2, textTransform: 'uppercase', color: 'var(--text-light)', marginTop: 1 }}>Admin Panel</div>
          </div>
        </div>
      </div>

      <nav className="admin-nav">
        {navItems.map((item, i) =>
          item.section ? (
            <div key={i} className="nav-section">{item.section}</div>
          ) : (
            <NavLink key={item.to} to={item.to}
              className={({ isActive }) => `nav-item ${isActive ? 'active' : ''}`}
              onClick={() => setSidebarOpen(false)}>
              <i className={`bi ${item.icon}`} style={{ fontSize: 16 }} />
              {item.label}
            </NavLink>
          )
        )}
      </nav>

      <div style={{ padding: '16px 10px', borderTop: '1px solid var(--border)' }}>
        <NavLink to="/" target="_blank" className="nav-item" style={{ display: 'flex' }}>
          <i className="bi bi-box-arrow-up-right" style={{ fontSize: 15 }} /> View Site
        </NavLink>
        <button onClick={handleLogout} className="nav-item w-100" style={{ color: 'var(--danger)' }}>
          <i className="bi bi-box-arrow-left" style={{ fontSize: 15 }} /> Logout
        </button>
      </div>
    </div>
  );

  return (
    <div className="admin-layout">
      <Sidebar />
      {sidebarOpen && (
        <div onClick={() => setSidebarOpen(false)}
          style={{ position: 'fixed', inset: 0, background: 'rgba(44,40,64,0.35)', zIndex: 99 }} />
      )}
      <div className="admin-content">
        <div className="admin-topbar">
          <div className="d-flex align-items-center gap-3">
            <button className="d-lg-none" onClick={() => setSidebarOpen(!sidebarOpen)}
              style={{ background: 'none', border: 'none', color: 'var(--text)', fontSize: 22, cursor: 'pointer' }}>
              <i className="bi bi-list" />
            </button>
            <p style={{ margin: 0, fontSize: '0.875rem', color: 'var(--text-muted)' }}>
              Welcome, <span style={{ color: 'var(--c4-dark)', fontWeight: 600 }}>{user?.name}</span>
            </p>
          </div>
          <div className="d-flex align-items-center gap-3">
            <div style={{ width: 34, height: 34, borderRadius: '50%', background: 'linear-gradient(135deg,var(--c3),var(--c4))', display: 'flex', alignItems: 'center', justifyContent: 'center', fontWeight: 700, fontSize: 14, color: '#fff' }}>
              {user?.name?.charAt(0).toUpperCase()}
            </div>
          </div>
        </div>
        <div className="admin-page">
          <Outlet />
        </div>
      </div>
    </div>
  );
}
